import { ServiceLoader } from 'components/common/Loading';
import { Layout } from 'components/Layout';
import React, { FC, Fragment, lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { RoutePaths } from './RoutePaths';
import { AvailableLanguages, useLanguage } from 'components/Layout/Language/useLanguage';
import { ProtectedRoute } from 'routes/ProtectedRoute';

const TermsOfUseLayout = lazy(() => import('components/Pages/TermsOfUse/TermsOfUseLayout'));
const DisclaimerLayout = lazy(() => import('components/Pages/DisclaimerPage/DisclaimerPage'));
const DisclaimerLastValidatedLayout = lazy(() => import('components/Pages/DisclaimerPage/DisclaimerLastValidated'));
const CountryRestrictedLayout = lazy(() => import('components/Pages/DisclaimerPage/CountryRestrictedLayout'));

export const AppRoutes: React.FC = () => {
    return <Layout>
        <Suspense fallback={<div className="d-flex justify-content-center"><ServiceLoader /></div>}>
            <Routes>
                {AvailableLanguages.map(lng => <Fragment key={lng}>
                    <Route path={RoutePaths.Home.route(lng)} element={<TermsOfUseLayout />} />
                    <Route path={RoutePaths.TermsOfUse.Client.route(lng)} element={<TermsOfUseLayout />} />
                    <Route path={RoutePaths.TermsOfUse.Contact.route(lng)} element={<TermsOfUseLayout />} />
                </Fragment>)}

                <Route
                    path={RoutePaths.Disclaimer.ByApplication.route}
                    element={<ProtectedRoute><DisclaimerLayout /></ProtectedRoute>}
                />
                <Route
                    path={RoutePaths.Disclaimer.Validated.route}
                    element={<ProtectedRoute><DisclaimerLastValidatedLayout /></ProtectedRoute>}
                />
                <Route
                    path={RoutePaths.Disclaimer.CountryRestricted.route}
                    element={<ProtectedRoute><CountryRestrictedLayout /></ProtectedRoute>}
                />

                <Route path="*" element={<RedirectComponent />} />
            </Routes>
        </Suspense>
    </Layout>;
};

const RedirectComponent: FC = () => {
    const { selectedLanguage, urlLanguage } = useLanguage();
    const { pathname, search, hash } = useLocation();

    if (urlLanguage) {
        // Route already have language in URL, but no route where found. Redirect to the home
        return <Navigate to={RoutePaths.Home.url(urlLanguage)} />;
    }

    // Route doesn't have language in URL. Add it.
    return <Navigate to={`/${selectedLanguage}${pathname}${search}${hash}`} />;
};